import { useEffect, useState } from 'react';
import classnames from 'classnames';
import ModalSecret from './ModalSecret';
import GlobalService from '../../../../../services/Global.service';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';

const SECRET_KEY = {
    PUBLIC: '30a9cb5e53814e70bfgnf4397ea9ea6b',
    CONFIDENTIAL: '42390175dev4486e933df5442f9d28ce',
    TOP_SECRET: '489276f252c0491ka0672101eb0a5a9f',
    SECRET: 't6b4d477f7ce4fc289dc95b80d251t6p',
    INTERNAL_USER: 'fbb4d477f7ce4fc289dc95b53d2519b3',
};

const getIcon = (id) => {
    return {
        [SECRET_KEY.PUBLIC]: (
            <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="14" cy="14" r="13.5" stroke="#0BB783" />
                <circle cx="13.9996" cy="14.0001" r="9.72222" fill="#0BB783" />
            </svg>
        ),
        [SECRET_KEY.INTERNAL_USER]: (
            <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="14" cy="14" r="13.5" stroke="#98DD40" />
                <circle cx="13.9996" cy="14.0001" r="9.72222" fill="#98DD40" />
            </svg>
        ),
        [SECRET_KEY.CONFIDENTIAL]: (
            <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="14" cy="14" r="13.5" stroke="#FAD40B" />
                <circle cx="13.9996" cy="14.0001" r="9.72222" fill="#FAD40B" />
            </svg>
        ),
        [SECRET_KEY.SECRET]: (
            <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="14" cy="14" r="13.5" stroke="#FFA800" />
                <circle cx="13.9996" cy="14.0001" r="9.72222" fill="#FFA800" />
            </svg>
        ),
        [SECRET_KEY.TOP_SECRET]: (
            <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="14" cy="14" r="13.5" stroke="#F64E60" />
                <circle cx="13.9996" cy="14.0001" r="9.72222" fill="#F64E60" />
            </svg>
        ),
    }[id];
};

export default function Secret({
    getRoPaDetailHeader,
    secretLevelId,
    editMode,
}) {
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);
    const [color, setColor] = useState('#0BB783');

    const [secrets, setSecrets] = useState([]);
    const [selected, setSelected] = useState();

    useEffect(() => {
        const getSecret = async () => {
            try {
                const { data } = await GlobalService.getSecret();
                if (data?.resultData) {
                    let secrets = [];
                    for (let secret of data?.resultData) {
                        secrets.push({
                            ...secret,
                            icon: getIcon(secret.id),
                        });
                    }
                    if (secretLevelId) {
                        let select = secrets?.find(
                            (s) => s.id === secretLevelId
                        );
                        setSelected(select);
                    } else {
                        setSelected(secrets[0]);
                    }
                    setSecrets(secrets);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getSecret();

        if (secretLevelId === SECRET_KEY.PUBLIC) {
            setColor('#0BB783');
        }
        if (secretLevelId === SECRET_KEY.CONFIDENTIAL) {
            setColor('#FAD40B');
        }
        if (secretLevelId === SECRET_KEY.SECRET) {
            setColor('#FFA800');
        }
        if (secretLevelId === SECRET_KEY.TOP_SECRET) {
            setColor('#F64E60');
        }
        if (secretLevelId === SECRET_KEY.INTERNAL_USER) {
            setColor('#F64E60');
        }
    }, [secretLevelId]);

    const name = secrets?.find((s) => s.id === secretLevelId);

    return (
        <div className="col-span-1 bg-white h-max rounded-xl p-4 py-6 my-4 group">
            <div
                className="text-sm font-semibold pb-2 flex justify-between items-center"
                style={{ borderBottom: '3px solid #F4F6FC' }}
            >
                <span>
                    {t('RoPA.LevelOfConfidentiality')}{' '}
                    <span className="text-[13px] text-[#ff4d4f] align-middle">
                        {' '}
                        *
                    </span>
                </span>
                <div className="flex">
                    <Tooltip
                        placement="right"
                        overlayClassName="min-w-[320px]"
                        title={
                            <div className="whitespace-pre-line">
                                {t('RoPA.LevelOfConfidentialityTooltip')}
                            </div>
                        }
                    >
                        <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="30"
                                height="30"
                                rx="6"
                                fill="#F3F6F9"
                            />
                            <g clipPath="url(#clip0_353_9074)">
                                <path
                                    d="M15 9C13.4087 9 11.8826 9.63214 10.7574 10.7574C9.63214 11.8826 9 13.4087 9 15C9 16.5913 9.63214 18.1174 10.7574 19.2426C11.8826 20.3679 13.4087 21 15 21C16.5913 21 18.1174 20.3679 19.2426 19.2426C20.3679 18.1174 21 16.5913 21 15C21 13.4087 20.3679 11.8826 19.2426 10.7574C18.1174 9.63214 16.5913 9 15 9ZM7.5 15C7.5 10.8578 10.8578 7.5 15 7.5C19.1423 7.5 22.5 10.8578 22.5 15C22.5 19.1423 19.1423 22.5 15 22.5C10.8578 22.5 7.5 19.1423 7.5 15Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M15 13.5C15.1989 13.5 15.3897 13.579 15.5303 13.7197C15.671 13.8603 15.75 14.0511 15.75 14.25V18.75C15.75 18.9489 15.671 19.1397 15.5303 19.2803C15.3897 19.421 15.1989 19.5 15 19.5C14.8011 19.5 14.6103 19.421 14.4697 19.2803C14.329 19.1397 14.25 18.9489 14.25 18.75V14.25C14.25 14.0511 14.329 13.8603 14.4697 13.7197C14.6103 13.579 14.8011 13.5 15 13.5ZM16.125 11.625C16.125 11.9234 16.0065 12.2095 15.7955 12.4205C15.5845 12.6315 15.2984 12.75 15 12.75C14.7016 12.75 14.4155 12.6315 14.2045 12.4205C13.9935 12.2095 13.875 11.9234 13.875 11.625C13.875 11.3266 13.9935 11.0405 14.2045 10.8295C14.4155 10.6185 14.7016 10.5 15 10.5C15.2984 10.5 15.5845 10.6185 15.7955 10.8295C16.0065 11.0405 16.125 11.3266 16.125 11.625Z"
                                    fill="#7B67FB"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_353_9074">
                                    <rect
                                        width="15"
                                        height="15"
                                        fill="white"
                                        transform="translate(7.5 7.5)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                    </Tooltip>
                    <button
                        hidden={!editMode}
                        onClick={() => setIsOpen(true)}
                        className="cursor-pointer pl-2"
                    >
                        <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="30"
                                height="30"
                                rx="6"
                                fill="#F3F6F9"
                            />
                            <path
                                d="M19.3675 8.75732L21.2425 10.6323L19.8131 12.0623L17.9381 10.1873L19.3675 8.75732ZM12.5 17.4998H14.375L18.9294 12.9454L17.0544 11.0704L12.5 15.6248V17.4998Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M19.375 19.375H12.5988C12.5825 19.375 12.5656 19.3813 12.5494 19.3813C12.5288 19.3813 12.5081 19.3756 12.4869 19.375H10.625V10.625H14.9044L16.1544 9.375H10.625C9.93562 9.375 9.375 9.935 9.375 10.625V19.375C9.375 20.065 9.93562 20.625 10.625 20.625H19.375C19.7065 20.625 20.0245 20.4933 20.2589 20.2589C20.4933 20.0245 20.625 19.7065 20.625 19.375V13.9575L19.375 15.2075V19.375Z"
                                fill="#7B67FB"
                            />
                        </svg>
                    </button>
                </div>
            </div>
            {secretLevelId ? (
                <div className="text-center">
                    <div className="flex justify-center items-center space-x-4 pt-8">
                        <SvgGray
                            color="#0BB783"
                            active={secretLevelId === SECRET_KEY.PUBLIC}
                        />
                        <SvgGray
                            color="#98DD40"
                            active={secretLevelId === SECRET_KEY.INTERNAL_USER}
                        />
                        <SvgGray
                            color="#FAD40B"
                            active={secretLevelId === SECRET_KEY.CONFIDENTIAL}
                        />
                        <SvgGray
                            color="#FFA800"
                            active={secretLevelId === SECRET_KEY.SECRET}
                        />
                        <SvgGray
                            color="#F64E60"
                            active={secretLevelId === SECRET_KEY.TOP_SECRET}
                        />
                    </div>
                    <p
                        className="text-base font-semibold mt-4"
                        style={{ color }}
                    >
                        {name?.name}
                    </p>
                </div>
            ) : (
                <div className="text-center pt-4 flex flex-col items-center justify-center">
                    <button
                        className="relative w-max"
                        onClick={() => {
                            if (editMode) setIsOpen(true);
                        }}
                    >
                        <svg
                            width="63"
                            height="63"
                            viewBox="0 0 63 63"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                opacity="0.2"
                                cx="31.5"
                                cy="31.5"
                                r="23.625"
                                fill="#1890FF"
                            />
                            <circle
                                cx="31.2951"
                                cy="31.4997"
                                r="17.1818"
                                fill="#1890FF"
                            />
                            <g clipPath="url(#clip0_4746_247803)">
                                <path
                                    d="M32.3375 25.0479H29.9086V29.9057H25.0508V32.3346H29.9086V37.1924H32.3375V32.3346H37.1954V29.9057H32.3375V25.0479Z"
                                    fill="white"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_4746_247803">
                                    <rect
                                        width="19.6364"
                                        height="19.6364"
                                        fill="white"
                                        transform="translate(21.4766 21.6816)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                        <div
                            className={classnames(
                                'w-[63px] h-[63px] bg-[#1890FF] opacity-10 rounded-full absolute top-0',
                                {
                                    'group-hover:animate-ping cursor-pointer':
                                        editMode,
                                }
                            )}
                        ></div>
                    </button>
                    <div className="text-[#65707A] font-semibold text-base">
                        {t('RoPA.PleaseSpecifyDataConfidentialityLevel')}
                    </div>
                    <div className="text-[#F0536F] text-[12px]">
                        {t('errorText.requiredField2')}
                    </div>
                </div>
            )}
            <ModalSecret
                secrets={secrets}
                selected={selected}
                setSelected={setSelected}
                getRoPaDetailHeader={getRoPaDetailHeader}
                open={isOpen}
                handelClose={() => setIsOpen(false)}
            />
        </div>
    );
}

const SvgGray = ({ color = '#C3C4CB', active }) => (
    <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="15.5"
            cy="15"
            r="14.5"
            stroke={active ? color : '#C3C4CB'}
        />
        <circle
            cx="15.4987"
            cy="15.0002"
            r="10.4167"
            fill={active ? color : '#C3C4CB'}
        />
    </svg>
);
